module.exports = __webpack_public_path__ + "static/media/wheeling_station_marker.930d16c9.png";